<!-- src/components/ProfitCalculator/TargetCalculator.vue -->
<template>
  <div>
    <el-form-item label="目标收益">
      <el-input-number
        :model-value="targetProfit"
        :min="0"
        :step="1000"
        @update:model-value="handleTargetProfitChange">
        <template #append>元</template>
      </el-input-number>
    </el-form-item>

    <el-form-item label="成本价">
      <el-input-number
        :model-value="costPrice"
        :min="0"
        :step="0.1"
        @update:model-value="handleCostPriceChange">
        <template #append>元</template>
      </el-input-number>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'TargetCalculator',
  props: {
    targetProfit: {
      type: Number,
      default: 30000
    },
    costPrice: {
      type: Number,
      default: 100
    }
  },
  emits: ['update:targetProfit', 'update:costPrice'],
  methods: {
    handleTargetProfitChange(value) {
      this.$emit('update:targetProfit', value);
    },

    handleCostPriceChange(value) {
      this.$emit('update:costPrice', value);
    }
  }
}
</script>
